<template>
    <div class="container">
        <div>
            <div class="fl-x fl-a-s">
                <span class="fl-x fl-a-c mt-5 font-manrope-medium mr-2">
                    <span>Blog</span>
                    <i class="fa fa-angle-right"></i>
                </span>

                <span
                    class="fl-x mt-5 font-manrope-bold text-primary breadcrumb-title"
                    v-if="data.title"
                >
                    {{ data.title }}
                </span>
            </div>

            <h2
                v-if="data.title"
                class="mt-4 font-manrope-bold text-primary pb-3 bb-black fs-lg-8 title"
            >
                {{ data.title }}
            </h2>
        </div>

        <!-- Author & Date -->
        <div class="row align-items-start mt-3">

            <div class="col-lg-10 col-md-9 col-12">
                <div
                    v-if="data.author_name"
                    class="font-manrope-bold fs-2 text-primary author"
                >
                    {{ data.author_name }}
                </div>
            </div>

            <div
                class="col-lg-2 col-md-3 col-12 text-lg-right text-md-right text-left date"
            >
                {{ data.create_date }}
            </div>

        </div>

        <hr>
    </div>
</template>

<script>
export default {
    name: 'cybersecurity',
    props: {
        data: {
            type: Object,
            default: null
        }
    }
};
</script>

<style scoped>

.title{
    word-break: break-word;
    overflow-wrap: anywhere;
}

.breadcrumb-title{
    word-break: break-word;
    overflow-wrap: anywhere;
}

.author{
    word-break: break-word;
    overflow-wrap: anywhere;
    line-height: 1.6;
}

.date{
    font-weight:700;
    white-space: nowrap;
}

hr{
    width:100%;
    border:1px solid #837f7f;
    margin-top:20px;
}

@media (max-width:768px){

    .date{
        margin-top:10px;
        text-align:left !important;
    }

}
</style>
